import React from 'react'

const UpdateShift = () => {
  return (
    <div>
      UpdateShift
    </div>
  )
}

export default UpdateShift
